import React, { useState } from "react";
import styles from "./HeaderComp.module.scss";
import logo from "../assets/Images/CompanyLogo.svg";
import FirtsockLogo from "../assets/Images/firstockLogoBadge.svg";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import {
  Button,
  FormControl,
  LinearProgress,
  Menu,
  MenuItem,
  Select,
} from "@mui/material";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import logouticon from "../assets/Images/logouticon.svg";
import { confirmAlert } from "react-confirm-alert";
import pangreen from "../../Components/assets/Images/panicongreen.svg";
import pangrey from "../../Components/assets/Images/panicongrey.svg";
import aadhargreen from "../../Components/assets/Images/aadharicongreen.svg";
import aadhargrey from "../../Components/assets/Images/aadharicongrey.svg";
import profilegreen from "../../Components/assets/Images/profileicongreen.svg";
import profilegrey from "../../Components/assets/Images/profileicongrey.svg";
import ipvgreen from "../../Components/assets/Images/ipvicongreen.svg";
import ipvgrey from "../../Components/assets/Images/ipvicongrey.svg";
import bankgreen from "../../Components/assets/Images/bankicongreen.svg";
import bankgrey from "../../Components/assets/Images/bankicongrey.svg";
import nomineegreen from "../../Components/assets/Images/nomineeicongreen.svg";
import nomineegrey from "../../Components/assets/Images/nomineeicongrey.svg";
import uploadgreen from "../../Components/assets/Images/uploadicongreen.svg";
import uploadgrey from "../../Components/assets/Images/uploadicongrey.svg";
import esigngreen from "../../Components/assets/Images/esignicongreen.svg";
import esigngrey from "../../Components/assets/Images/esignicongrey.svg";
import tradinggrey from "../../Components/assets/Images/tradingicongrey.svg";
import tradinggreeen from "../../Components/assets/Images/tradingicongreen.svg";
import tcgrey from "../../Components/assets/Images/tandcicongrey.svg";
import tcgreeen from "../../Components/assets/Images/tandcicongreen.svg";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useSelector } from "react-redux";

const Stages = [
  {
    title: "Contact Details",
    iconGreen: <img src={pangreen} />,
    iconGrey: <img src={pangrey} />,
  },
  {
    title: "Trading Preference",
    iconGreen: <img src={tradinggreeen} />,
    iconGrey: <img src={tradinggrey} />,
  },
  {
    title: "PAN Validation",
    iconGreen: <img src={pangreen} />,
    iconGrey: <img src={pangrey} />,
  },

  {
    title: "About Yourself",
    iconGreen: <img src={profilegreen} />,
    iconGrey: <img src={profilegrey} />,
  },

  {
    title: "Passport Details",
    iconGreen: <img src={aadhargreen} />,
    iconGrey: <img src={aadhargrey} />,
  },
  {
    title: "Bank Account",
    iconGreen: <img src={bankgreen} />,
    iconGrey: <img src={bankgrey} />,
  },
  {
    title: "Address Details",
    iconGreen: <img src={aadhargreen} />,
    iconGrey: <img src={aadhargrey} />,
  },

  {
    title: "Fatca",
    iconGreen: <img src={tcgreeen} />,
    iconGrey: <img src={tcgrey} />,
  },
  {
    title: "Nominee",
    iconGreen: <img src={nomineegreen} />,
    iconGrey: <img src={nomineegrey} />,
  },
  {
    title: "Document Upload",
    iconGreen: <img src={uploadgreen} />,
    iconGrey: <img src={uploadgrey} />,
  },

  {
    title: "Form Preview",
    iconGreen: <img src={esigngreen} />,
    iconGrey: <img src={esigngrey} />,
  },
];

const MappingValues: any = {
  mobile: "Contact Details",

  segment: "Trading Preference",
  pan: "PAN Validation",
  customer_details: "About Yourself",
  passport_details: "Passport Details",
  bank: "Bank Account",
  pis_bank: "Bank Account",
  address_details: "Address Details",
  fatca: "Fatca",

  nominee: "Nominee",

  document_upload: "Document Upload",
  form_preview: "Form Preview",
};

function HeaderComp() {
  const pathName = useSelector((state: any) => state.PATHNAME.pathname);
  const completedstages = useSelector(
    (state: any) => state.PATHNAME.completedstages
  );
  const currentstage = useSelector((state: any) => state.PATHNAME.currentstage);
  const [openMenu, setOpenMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getKeyByValue = (obj: any, value: string) => {
    return Object.keys(obj).find((key) => obj[key] === value);
  };

  const handleLogout = () => {
    confirmAlert({
      title: "",
      message: "Are you sure you want to logout?",
      buttons: [
        {
          label: "No",
          onClick: () => "",
        },
        {
          label: "Yes",
          onClick: () => {
            sessionStorage.clear();
            window.location.href = "/";
          },
        },
      ],
    });
  };

  console.log("MappingValues", currentstage);
  return (
    <div className={styles.mainWrapper}>
      <div className={styles.leftContainer}
      >
    
          <img
            src={FirtsockLogo}
            style={{ zIndex: 100, cursor: "pointer" }}
            onClick={() => {}}
            className={styles.Logo}
          />
           <span className={styles.logoText}>Firstock</span>
      
      </div>
      <div className={styles.rightContainer}>
        {pathName === "/" ||
        pathName === "/confirm_otp" ||
        pathName === "/email" ||
        pathName === "/confirmemailotp" ? (
          <div className={styles.needHelpSection} style={{ marginTop: "3px" }}>
            <FormControl fullWidth>
              <Button
                onClick={handleClick}
                sx={{
                  background: "black",
                  color: "white",
                  textTransform: "none",
                  width: { xs: "100%", sm: "110%" },
                  justifyContent: "center",
                  height: "40px",
                  "&:hover": {
                    background: "black",
                  },
                }}
              >
                Need any Help?
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  sx: {
                    "& .Mui-selected": {
                      backgroundColor: "white",
                      color: "black",
                      "&:hover": {
                        backgroundColor: "white",
                      },
                    },
                  },
                }}
                PaperProps={{
                  sx: {
                    borderRadius: "10px",
                    marginTop: "5px",
                  },
                }}
              >
                <div
                  // onClick={(event) => {
                  //   event.stopPropagation();
                  //   console.log("+91-9900199801 clicked");
                  // }}
                  style={{
                    background: "white",
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    padding: "8px 15px",
                  }}
                >
                  <WhatsAppIcon sx={{ marginRight: "3px", fontSize: "16px" }} />
                  +91-9900199801
                </div>
                <div
                  style={{
                    background: "white",
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    padding: "8px 15px",
                  }}
                >
                  <PhoneInTalkIcon
                    sx={{ marginRight: "3px", fontSize: "16px" }}
                  />
                  080 4670 2020
                </div>
                <div
                  style={{
                    background: "white",
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    padding: "8px 15px",
                  }}
                >
                  <MailOutlineIcon
                    sx={{ marginRight: "3px", fontSize: "16px" }}
                  />
                  support@thefirstock.com
                </div>
              </Menu>
            </FormControl>
          </div>
        ) : (
          ""
        )}
        {pathName !== "/" &&
          pathName !== "/email" &&
          pathName !== "/confirm_otp" &&
          pathName !== "/confirmemailotp" &&
          pathName !== "/ekyc_esign" &&
          pathName !== "/completed" &&
          pathName !== "/congratulations" && (
            <>
              <div
                className={styles.dropSection}
                onClick={() => {
                  setOpenMenu(!openMenu);
                }}
              >
                {completedstages?.length === 0
                  ? "Contact Details"
                  : MappingValues[currentstage]}{" "}
                <ExpandCircleDownOutlinedIcon
                  style={{
                    color: "#049981",
                    transform: openMenu ? "rotateX(-180deg)" : "",
                    transition: "0.5s ease",
                  }}
                />
              </div>
              <div
                className={styles.dropSectionMobile}
                onClick={() => {
                  setOpenMenu(!openMenu);
                }}
              >
                {openMenu ? <CloseOutlinedIcon /> : <MenuOutlinedIcon />}
              </div>
            </>
          )}
        {openMenu && (
          <div className={styles.dropOptions}>
            <div className={styles.progressSection}>
              <div className={styles.progress}>
                <LinearProgress
                  variant="determinate"
                  value={completedstages?.length * 9}
                  color="inherit"
                  sx={{
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: "#049981",
                      borderRadius: "5px",
                    },
                  }}
                  style={{
                    borderRadius: "5px",

                    color: "rgba(0, 0, 0, 0.40)",
                  }}
                />
              </div>

              <p className={styles.progressPercent}>
                {completedstages?.length * 9}%
              </p>
            </div>
            <div className={styles.stagesSection}>
              {Stages.map((a: any, index: any) => {
                const stageKey: any = getKeyByValue(MappingValues, a.title);
                const isCompleted = completedstages.filter(
                  (a: any) => a == stageKey
                );

                return (
                  <div
                    className={styles.stageContainer}
                    style={{ color: isCompleted?.length ? "#049981" : "" }}
                  >
                    {isCompleted?.length ? a.iconGreen : a.iconGrey}
                    {a.title}{" "}
                    {isCompleted?.length ? (
                      <DoneAllOutlinedIcon sx={{ fontSize: "18px" }} />
                    ) : (
                      ""
                    )}
                  </div>
                );
              })}
            </div>

            <div className={styles.needHelpSection}>
              <FormControl fullWidth>
                <Button
                  onClick={handleClick}
                  sx={{
                    background: "black",
                    color: "white",
                    textTransform: "none",
                    width: "100%",
                    justifyContent: "center",
                    height: "40px",
                    "&:hover": {
                      background: "black",
                    },
                  }}
                >
                  Need any Help?
                </Button>
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    sx: {
                      "& .Mui-selected": {
                        backgroundColor: "white",
                        color: "black",
                        "&:hover": {
                          backgroundColor: "white",
                        },
                      },
                    },
                  }}
                  PaperProps={{
                    sx: {
                      borderRadius: "10px",
                      marginTop: "5px",
                    },
                  }}
                >
                  <div
                    // onClick={(event) => {
                    //   event.stopPropagation();
                    //   console.log("+91-9900199801 clicked");
                    // }}
                    style={{
                      background: "white",
                      fontSize: "12px",
                      display: "flex",
                      alignItems: "center",
                      padding: "8px 15px",
                    }}
                  >
                    <WhatsAppIcon
                      sx={{ marginRight: "3px", fontSize: "16px" }}
                    />
                    +91-9900199801
                  </div>
                  <div
                    style={{
                      background: "white",
                      fontSize: "12px",
                      display: "flex",
                      alignItems: "center",
                      padding: "8px 15px",
                    }}
                  >
                    <PhoneInTalkIcon
                      sx={{ marginRight: "3px", fontSize: "16px" }}
                    />
                    080 4670 2020
                  </div>
                  <div
                    style={{
                      background: "white",
                      fontSize: "12px",
                      display: "flex",
                      alignItems: "center",
                      padding: "8px 15px",
                    }}
                  >
                    <MailOutlineIcon
                      sx={{ marginRight: "3px", fontSize: "16px" }}
                    />
                    support@thefirstock.com
                  </div>
                </Menu>
              </FormControl>
            </div>
            <div className={styles.logoutSection}>
              <Button
                onClick={handleLogout}
                variant="outlined"
                endIcon={<img src={logouticon} />}
                sx={{
                  color: "#111827",
                  width: "100%",
                  height: "40px",
                  fontSize: "14px",
                  fontWeight: 500,
                  border: "1.5px solid var(--Red-Black-Black-200, #E5E7EB)",
                  "&:hover": {
                    background: "white",
                    border: "1.5px solid var(--Red-Black-Black-200, #E5E7EB)",
                  },
                }}
              >
                Logout
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default HeaderComp;
